import { IIconBase } from '..'

const eyeIcon = ({ color = '#333752', height = 14, width = 14 }: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.08829 6.99995C9.08829 8.15495 8.15495 9.08829 6.99995 9.08829C5.84495 9.08829 4.91162 8.15495 4.91162 6.99995C4.91162 5.84495 5.84495 4.91162 6.99995 4.91162C8.15495 4.91162 9.08829 5.84495 9.08829 6.99995Z'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.99991 11.8241C9.05908 11.8241 10.9782 10.6108 12.3141 8.51075C12.8391 7.68825 12.8391 6.30575 12.3141 5.48325C10.9782 3.38325 9.05908 2.16992 6.99991 2.16992C4.94074 2.16992 3.02158 3.38325 1.68574 5.48325C1.16074 6.30575 1.16074 7.68825 1.68574 8.51075C3.02158 10.6108 4.94074 11.8241 6.99991 11.8241Z'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default eyeIcon
